import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../Utility/Button';
import { X } from '@phosphor-icons/react';
import { setModal } from '../../Store/Actions/modalActions';

const Modal: React.FC = () => {
    const dispatch = useDispatch();
    const {
        state,
        title,
        content,
        buttonRightText,
        buttonRightAction,
        buttonRightVariant,
        showRightButton,
        buttonLeftText,
        buttonLeftAction,
        buttonLeftVariant,
        showLeftButton,
        modalSize,
        closeOnAction,
        showCloseButton,
        closeFunction,
        customButtons,
    } = useSelector((state: any) => state.modal.modal);
    const i18n = useSelector((state: any) => state.i18n.i18n);
    if (state !== 'open') return null;

    const handleClose = () => {
        dispatch(
            setModal({
                state: 'closed',
                title: '',
                content: '',
                buttonRightText: null,
                buttonRightAction: null,
                buttonRightVariant: 'primary',
                showRightButton: true,
                buttonLeftText: null,
                buttonLeftAction: null,
                buttonLeftVariant: 'secondary',
                showLeftButton: true,
                modalSize: 'small',
                closeOnAction: false,
                showCloseButton: true,
                closeFunction: null,
                customButtons: [],
            }),
        );
    };

    const getModalSizeClass = () => {
        switch (modalSize) {
            case 'medium':
                return 'max-w-2xl';
            case 'large':
                return 'max-w-6xl';
            case 'full':
                return '!w-[90dvw] h-[80dvh]';
            // case 'small':
            default:
                return 'max-w-lg';
        }
    };

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[2]"
            onClick={() => {
                closeFunction && closeFunction();
                handleClose();
            }}
            onScroll={(e) => e.stopPropagation()}
        >
            <div
                className={`bg-modalBackground rounded-lg py-8 mx-3 w-full relative ${getModalSizeClass()}`}
                onClick={(e) => e.stopPropagation()}
            >
                {showCloseButton && (
                    <div className="absolute top-3 right-3">
                        <Button
                            variant="secondaryRound"
                            onClick={() => {
                                closeFunction && closeFunction();
                                handleClose();
                            }}
                        >
                            <X size={18} />
                        </Button>
                    </div>
                )}
                <h4 className="text-themeswitch-headline text-themeswitch-headlineColor font-normal pl-8 pt-0 mt-0 mb-4 w-[calc(100%-66px)]">
                    {title}
                </h4>
                {typeof content === 'string' ? (
                    <div
                        className={`${
                            modalSize === 'full' ? 'max-h-[70dvh] ' : 'max-h-[calc(var(--app-height)/2)] '
                        } overflow-y-auto text-layout-textcolor px-8`}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                ) : (
                    <div
                        className={`${
                            modalSize === 'full' ? 'max-h-[70dvh] ' : 'max-h-[calc(var(--app-height)/2)] '
                        } overflow-y-auto px-8`}
                    >
                        {content}
                    </div>
                )}
                {showLeftButton === false && showRightButton === false && customButtons && customButtons.length > 0 && (
                    <div className="mt-6 flex justify-end space-x-2 px-8">
                        {customButtons.map((button: any, index: number) => {
                            return (
                                <div
                                    key={index}
                                    onClick={() => {
                                        handleClose();
                                    }}
                                >
                                    {button}
                                </div>
                            );
                        })}
                    </div>
                )}
                {(showLeftButton || showRightButton) && (
                    <div className="mt-6 flex justify-end space-x-2 px-8">
                        {showLeftButton && (
                            <Button
                                variant={buttonLeftVariant || 'secondaryOutlined'}
                                onClick={() => {
                                    if (buttonLeftAction) buttonLeftAction();
                                    if (closeFunction) closeFunction();
                                    if (closeOnAction) handleClose();
                                }}
                            >
                                {buttonLeftText ??
                                    i18n.translate({ id: 'closeConfirmDialog.button', sourceName: 'Main' })}
                            </Button>
                        )}
                        {showRightButton && (
                            <Button
                                variant={buttonRightVariant || 'primary'}
                                onClick={() => {
                                    if (buttonRightAction) buttonRightAction();
                                    if (closeOnAction) handleClose();
                                }}
                            >
                                {buttonRightText ??
                                    i18n.translate({ id: 'confirmDeleteChat.button', sourceName: 'Main' })}
                            </Button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Modal;
